import { render, staticRenderFns } from "./BookingGroupFields.vue?vue&type=template&id=2f38fd97&scoped=true&"
import script from "./BookingGroupFields.vue?vue&type=script&lang=js&"
export * from "./BookingGroupFields.vue?vue&type=script&lang=js&"
import style0 from "./BookingGroupFields.vue?vue&type=style&index=0&id=2f38fd97&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f38fd97",
  null
  
)

export default component.exports